import { render, staticRenderFns } from "./ProfileMobileNav.vue?vue&type=template&id=5daf7e8c&scoped=true&"
import script from "./ProfileMobileNav.vue?vue&type=script&lang=ts&"
export * from "./ProfileMobileNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf7e8c",
  null
  
)

export default component.exports